import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

/**
 * ProtectedRoute Component
 * Guards private routes in the Rutex Backoffice.
 * - Redirects unauthenticated users to /user-pages/login.
 * - Redirects users with required initial password changes to /user-pages/force-password-change.
 */
const ProtectedRoute = ({ children }) => {
  const { user, token, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/user-pages/login" state={{ from: location }} replace />;
  }

  if (user && (user.must_change_password || user.requires_password_change)) {
    if (location.pathname !== '/user-pages/force-password-change' && location.pathname !== '/actualizar-clave-inicial') {
      return <Navigate to="/user-pages/force-password-change" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
